import { getComponent } from '../utils'
import MultiTabLayout from '@/layouts/multi-tab-layout.vue'
import AuthLayout from '@/layouts/auth-layout.vue'
import { get_config } from '@/config'

const config = get_config()

import MainLayout from '@/layouts/main-layout.vue'
import PublicLayout from '@/layouts/public-layout.vue'
import { public_routes } from './public-routes'
import { assistant_routes } from './assistant-routes'
import { tool_routes } from './tool-routes'
import { auth_routes } from './auth-routes'
import { data_routes } from './data-routes'
import { model_routes } from './model-routes'
import { user_routes } from './user_routes'
import { org_routes } from './org-routes'
import { account_routes } from './account-routes'
import { org_admin_routes } from './org-admin-routes'
import { super_admin_routes } from './super-admin-routes'
import type { RouteRecordRaw } from 'vue-router'
import { ApartmentOutlined } from '@ant-design/icons-vue'
import { prefix } from '../prefix'
import { h } from 'vue'

const Layout = config.is_multitab ? MultiTabLayout : MainLayout

export const routes: Readonly<RouteRecordRaw[]> = [
  {
    path: '/',
    name: 'index',
    redirect: `/home`,
    children: [
      // Public routes
      ...public_routes,

      // Private routes
      {
        path: '/dashboard',
        name: 'dashboard',
        redirect: `/assistant/list`,
        // component: () => getComponent(`pages/dashboard.vue`),
        meta: { title: () => 'Dashboard', layout: Layout, is_public: false },
      },

      // WORK BENCH
      {
        path: '/workbench',
        name: 'workbench',
        component: () => getComponent(`pages/workbench.vue`),
        meta: {
          title: () => 'Workbench',
          layout: Layout,
          is_public: false,
          menu: {
            key: 'Workbench',
            label: 'Workbench',
            icon: () => h(ApartmentOutlined),
            path: `${prefix}/workbench`,
          },
        },
      },

      // ASSISTANT ROUTES
      ...assistant_routes,

      // TOOL ROUTES
      ...tool_routes,

      // AUTH ROUTES
      ...auth_routes,

      // DATA ROUTES
      ...data_routes,

      // MODEL ROUTES
      ...model_routes,

      // USER ROUTES
      ...user_routes,

      // ORG ROUTES
      ...org_routes,

      // ACCOUNT ROUTES
      ...account_routes,

      // ORG ADMIN ROUTES
      ...org_admin_routes,

      // SUPER ADMIN ROUTES
      ...super_admin_routes,
    ],
  },
  // ########################################
  // #            Error Routes              #
  // ########################################
  {
    path: '/:catchAll(.*)',
    component: () => getComponent(`components/errors/404.vue`),
    meta: { transition: 'fade', layout: PublicLayout, is_public: true },
  },
]
